import apiClient from "./axios";

export const getSessions = async (params?: Record<string, unknown>) =>
  apiClient.get("/logs/sessions", { params });

export const getSessionDetail = async (sessionId: string) =>
  apiClient.get(`/logs/sessions/${sessionId}`);

export const getTraces = async (params?: Record<string, unknown>) =>
  apiClient.get("/logs/traces", { params });
